export default "__VITE_ASSET__ce4511b9__"